<template>
  <div class="profile-detail">
    <line-text
      link
      :content="$t('profile.profile.avatar')"
      :data="userInfo.avatarUrl"
      class="avatar-line fix-padding-left">
      <template v-slot:data>
        <cube-upload
          ref="upload"
          v-model="avatar"
          :action="action"
          :simultaneous-uploads="1"
          :multiple="false"
          :auto="false"
          @input="cutAvatar">
          <div class="avatar-box">
            <cube-upload-btn :multiple="false">
              <x-avatar
                :avatarUrl="userInfo.avatarUrl"
                :personName="userInfo.username"
                class="personal-avatar"
              />
            </cube-upload-btn>
          </div>
        </cube-upload>
      </template>
    </line-text>
    <template v-for="column in columns">
      <line-text
        :key="column.name"
        link
        :content="column.label"
        :data="userInfo[column.name]"
        class="fix-padding-left"
        @click="handleClick(column.link, { data: userInfo[column.name], column: column })">
        <template v-if="column.name === 'sex'" v-slot:data>
          {{ lookupSex(userInfo['sex']) }}
        </template>
      </line-text>
    </template>
    <x-modal
      :visible.sync="cropperVisible">
      <div class="avatar-cropper-container">
        <vue-cropper
          ref="cropper"
          style="height: 250px;"
          :img="imgData"
          :outputType="'outputType'"
          :centerBox="true"
          :info="false"
          :infoTrue="true"
          :fixedBox="true"
          :canMoveBox="false"
          :outputSize="1"
          :autoCrop="true"
          :fixed="true"
          :fixedNumber="[2, 2]"
        ></vue-cropper>
        <cube-button class="ok-button" @click="handleAvatarOk">
          {{ $t('common.common.ok') }}
        </cube-button>
      </div>
    </x-modal>
  </div>
</template>

<script>
import LineText from '@/components/line-text/line-text.vue'
import XAvatar from '@/components/x-avatar/x-avatar.vue'
import apis from '../../../api'
import { mapMutations, mapState } from 'vuex'
import ParamsCatchMixin from '@/mixin/params-catch.mixin.js'
import Compressor from 'compressorjs'
import { VueCropper } from 'vue-cropper'

import {
  SET_USER_INFO
} from '@/store/auth.store.js'
import {
  SET_CURRENT_FIELD
} from '@/store/profile.store.js'
const SEX = [
  { text: '保密', value: 'SECRECY' },
  { text: '男', value: 'MALE' },
  { text: '女', value: 'FEMALE' }
]
export default {
  components: {
    LineText,
    VueCropper,
    XAvatar
  },
  mixins: [ParamsCatchMixin],
  data() {
    return {
      avatar: [],
      action: {
        withCredentials: true
      },
      columns: [
        {
          name: 'username',
          label: this.$t('profile.profile.name'),
          link: 'input'
        },
        {
          name: 'sex',
          label: this.$t('profile.profile.gender'),
          link: 'gender'
        },
        {
          name: 'birthday',
          label: this.$t('profile.profile.birthday'),
          link: 'date'
        },
        {
          name: 'position',
          label: this.$t('profile.profile.position'),
          link: 'input'
        },
        {
          name: 'company',
          label: this.$t('profile.profile.corporation'),
          link: 'input'
        },
        {
          name: 'personalProfile',
          label: this.$t('profile.profile.signature'),
          link: 'textarea'
        }
      ],
      cropperVisible: false,
      cropperModal: {
        okConfig: {
          title: this.$t('common.confirm'),
          onOk: () => {

          }
        },
        cancelConfig: {
          title: this.$t('common.cancel')
        }
      },
      imgData: ''
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.authModule.userInfo
    })
  },
  created() {
    this.queryUserInfo()
  },
  methods: {
    ...mapMutations('authModule', {
      setUserInfo: SET_USER_INFO
    }),
    ...mapMutations('profileModule', {
      setCurrentField: SET_CURRENT_FIELD
    }),
    isIE() {
      // ie?
      const agent = navigator.userAgent.toLowerCase()
      return agent.indexOf('trident') >= 0 || agent.indexOf('msie') >= 0
    },
    handleAvatarOk() {
      return new Promise((resolve, reject) => {
        resolve()
        // 获取截图的base64 数据
        this.$refs.cropper.getCropData((data) => {
          let outputData, fileName
          fileName = 'temp.png'
          if (this.isIe) {
            outputData = blobToFile(dataURLtoBlob(data), fileName)
          } else {
            outputData = dataURLtoFile(data, fileName)
          }
          if (outputData.size / 1024 > 150) {
            const _self = this
            /* eslint-disable no-new */
            new Compressor(outputData, {
              convertSize: 150000,
              quality: 0.6,
              maxWidth: 300,
              maxHeight: 300,
              success(result) {
                _self.uploadFile(result, outputData.name, resolve)
              },
              error(err) {
                console.err(err)
              }
            })
          } else {
            this.uploadFile(outputData, outputData.name, resolve)
          }
        })
      })
    },
    uploadFile(file, fileName, resolve) {
      console.log(file)
      const formData = new FormData()
      formData.append('file', file, fileName)
      formData.append('uploadId', '0')
      const request = { ...apis.PERSONAL_CENTER.UPLOAD_AVATAR }
      request.params = formData
      this.$upload(request)
        .asyncThen(
          (resp) => {
            if (resp.code === 'ok') {
              this.cropperVisible = false
              this.imgData = ' '
              this.uploadHandle(resp.data.id, resp.data.url)
              resolve(false)
            }
          },
          (error) => {
            console.error(error)
            resolve(true)
          }
        )
        .asyncErrorCatch((error) => {
          console.error(error)
          resolve(true)
        })
    },
    getFile: function() {
      return this.$refs.upload.files[0]
    },
    cutAvatar(filelist) {
      const file = filelist[0].file
      if (file) {
        const name = file.name.toLowerCase()
        if (name.endsWith('.png') || name.endsWith('.jpeg') || name.endsWith('.jpg')) {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onloadend = () => {
            this.imgData = reader.result
          }
          this.cropperVisible = true
        } else {
          this.$message({
            message: this.$t('profile.profile.avatarFormat'),
            type: 'error'
          })
        }
      } else {
        this.imgData = ' '
      }
    },
    lookupSex(sex) {
      const lookedUpSex = SEX.find(item => item.value === sex)
      return lookedUpSex ? lookedUpSex.text : ''
    },
    showDatePicker() {
      if (!this.datePicker) {
        this.datePicker = this.$createDatePicker({
          title: this.$t('profile.profile.birthday'),
          min: new Date(1908, 7, 8),
          max: new Date(),
          value: new Date(),
          onSelect: this.selectDateHandle
        })
      }
      this.datePicker.show()
    },
    saveInfo(profile) {
      const request = {
        ...apis.PERSONAL_CENTER.UPDATE_USER_USERINFO,
        params: {
          ...profile
        }
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.queryUserInfo()
          },
          () => {}
        )
        .asyncErrorCatch((error) => {})
    },
    selectDateHandle(date, selectedVal, selectedText) {
      const profile = this.$lodash.cloneDeep(this.userInfo)
      profile.birthday = selectedText[0] + '-' +
        selectedText[1] + '-' +
        selectedText[2]
      this.saveInfo(profile)
    },
    showPicker() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: this.$t('profile.profile.gender'),
          data: [SEX],
          onSelect: this.selectHandle
        })
      }
      this.picker.show()
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      const profile = this.$lodash.cloneDeep(this.userInfo)
      profile.sex = selectedVal[0]
      this.saveInfo(profile)
    },
    uploadHandle(id, url) {
      const profile = this.$lodash.cloneDeep(this.userInfo)
      profile.headPortrait = id
      profile.avatarUrl = url
      this.saveInfo(profile)
    },
    handleClick(type, data) {
      if (type === 'input') {
        if (data.column.name === 'username') {
          this.setCurrentField({ field: data, required: true })
        } else {
          this.setCurrentField({ field: data })
        }
        this.$router.push({
          name: 'edit-profile',
          params: {
            orgId: this.orgId
          },
          query: {
            title: data.column.label
          }
        })
      } else if (type === 'textarea') {
        this.setCurrentField({ field: data, textarea: true, maxLength: 200 })
        this.$router.push({
          name: 'edit-profile',
          params: {
            orgId: this.orgId
          },
          query: {
            title: data.column.label
          }
        })
      } else if (type === 'date') {
        this.showDatePicker()
      } else if (type === 'gender') {
        this.showPicker()
      }
    },
    queryUserInfo() {
      const request = { ...apis.PERSONAL_CENTER.QUERY_USER_INFO }
      this.$loading.show()
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.setUserInfo(resp.data)
            this.$loading.hide()
          },
          () => {
            this.$loading.hide()
          }
        )
        .asyncErrorCatch((error) => {
          this.$loading.hide()
        })
    }
  }
}

function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}
/**
 * @description: 将base64转换为文件
 * @param {String} dataurl
 * @param {String} filename
 * @return: {File}
 */
function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

// 将blob转换成file
function blobToFile(theBlob, fileName) {
  theBlob.lastModifiedDate = new Date()
  theBlob.name = fileName
  return theBlob
}

</script>

<style lang="scss" scoped>
.profile-detail {
  height: 100%;
  width: 100%;
  // padding-top: 3.14rem;
  background: $--app-body-bgColor;
  padding-top: .571rem;
  .avatar-line {
    margin-bottom: .571rem;
    height: 5.143rem;
    .personal-avatar {
      cursor: pointer;
      width: 2.857rem;
      height: 2.857rem;
    }
  }
}
</style>

<style lang="scss">
.avatar-cropper-container {
  .ok-button {
    background: $--app-primary-color;
  }
}
</style>
